import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApiError } from '@familywallet/api-client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './i18n';
import './index.css';
import { initTheme } from './lib/theme';

initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    // Errors the user can fix (403, 404, 422) should show at once, not after retries.
    queries: {
      retry: (count, error) => count < 2 && !(error instanceof ApiError && error.status < 500),
    },
  },
});
const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
